import { createSelector } from '@ngrx/store';
import { getOneClickState } from '@ordersnproducts/modules/one-click-order/reducers';

export const getOneClickVehiclesState = createSelector(
  getOneClickState,
  state => state.vehiclesState,
);

export const getOneClickVehicles = createSelector(
  getOneClickVehiclesState,
  state => state.vehiclesAvailable,
);

export const getOneClicVehiclesSelected = createSelector(
  getOneClickVehiclesState,
  state => state.selected,
);
